import React from "react";

export const InstantSearchResultsFallback = (props: any) => {
  const collections = JSON.parse(document.querySelector("#shopify-setting-data")?.innerHTML as string).search_popular_collection;

  return (
    <section className="instant-search__fallback-results-grid">
      {
        collections.map((collection : any) => {
          return (
            <div className="rs__result-card-product">
              <a
                className="rs__result-card-product__link"
                onClick={collection.handleClick}
                href={`/collections/${collection.handle}`}
              >
                {collection.image && (
                  <img
                    className="rs__result-card-product__image"
                    src={collection.image.src}
                    width="100%"
                  />
                )}
                <span className="rs__result-card-product__title">
                  {collection.title}
                </span>
              </a>     
            </div>
          );
        })
      }
    </section>
  );
};